(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halo-report-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('halo-report-form')) {
    customElements.define(
      'halo-report-form',
      class extends HTMLElement {
        connectedCallback() {
          if (!this.querySelector('.halo-report-form__success')) return;

          // Keep the success message now; restore the form on the next refresh.
          const url = new URL(window.location.href);
          if (url.searchParams.has('contact_posted')) {
            url.searchParams.delete('contact_posted');
            window.history.replaceState(window.history.state, '', url.toString());
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
